const PeliasResult = function (data) {
  let placeName = data.properties.label;

  this.id = data.properties.id;

  if (
    data.properties.layer === 'locality' ||
    data.properties.layer === 'borough'
  ) {
    this.city = data.properties.name;
  }

  this.state_long_name = data.properties.region;
  this.state_short_name = data.properties.region_a;

  this.country_long_name = data.properties.country;
  this.country_short_name = data.properties.country_code;

  if (this.city) {
    const stateDisplay = this.state_long_name || this.state_short_name;
    const countryDisplay = this.country_long_name || this.country_short_name;
    if (
      stateDisplay &&
      countryDisplay &&
      this.city !== stateDisplay &&
      stateDisplay !== countryDisplay
    ) {
      placeName = [this.city, stateDisplay, countryDisplay].join(', ');
    }
  }

  this.displayName = placeName;
  this.name = placeName;
  this.latitude = data.geometry.coordinates[1];
  this.longitude = data.geometry.coordinates[0];
};

export default PeliasResult;
